const DATE_FORMAT_TYPES = {
    es: {
        DATE_FORMAT: 'DD MMM YYYY',
        DATE_FORMAT_DAY_MONTH: 'DD MMM',
        DATE_FORMAT_EXTENDED: 'DD [de] MMM [de] YYYY',
        DATE_FORMAT_WITH_SLASHES: 'DD/MM/YYYY',
        DATE_FORMAT_WITH_DASHES: 'DD-MM-YYYY',
        DATE_FORMAT_WITH_DASHES_FIRST_YEAR: 'YYYY-MM-DD',
        DATE_FORMAT_DATETIME: 'DD MMM YYYY h:mm',
        DATE_FORMAT_SHORT_MONTH_YEAR: 'MMM YYYY',
        DATE_FORMAT_SHORT_MONTH_SHORT_YEAR: 'MM/YY',
        DATE_FORMAT_WITH_DASHES_DATETIME: 'YYYY-MM-DD - HH:mm',
        DATE_FORMAT_WITH_SLASHES_DATETIME: 'DD/MM/YYYY [-] HH:mm',
        DATE_FORMAT_TIMESERIES: 'YYYY-MM-DDThh:mm:ssZZ',
        DATE_FORMAT_TIME_REDUCED: 'YYYY-MM-DD_hhmmss',
    },
    en: {
        DATE_FORMAT: 'MMM DD YYYY',
        DATE_FORMAT_DAY_MONTH: 'MMM DD',
        DATE_FORMAT_EXTENDED: 'MMM DD YYYY',
        DATE_FORMAT_WITH_SLASHES: 'MM/DD/YYYY',
        DATE_FORMAT_WITH_DASHES: 'MM-DD-YYYY',
        DATE_FORMAT_WITH_DASHES_FIRST_YEAR: 'YYYY-MM-DD',
        DATE_FORMAT_SHORT_MONTH_SHORT_YEAR: 'MM/YY',
        DATE_FORMAT_SHORT_MONTH_YEAR: 'MMM YYYY',
        DATE_FORMAT_WITH_SLASHES_DATETIME: 'DD/MM/YYYY [-] HH:mm',
        DATE_FORMAT_TIMESERIES: 'YYYY-MM-DDThh:mm:ssZZ',
        DATE_FORMAT_TIME_REDUCED: 'YYYY-MM-DD_hhmmss',
    },
    de: {
        DATE_FORMAT: 'DD. MMM YYYY',
        DATE_FORMAT_DAY_MONTH: 'DD. MMM',
        DATE_FORMAT_EXTENDED: 'DD. MMM YYYY',
        DATE_FORMAT_WITH_SLASHES: 'DD/MM/YYYY',
        DATE_FORMAT_WITH_DASHES: 'DD-MM-YYYY',
        DATE_FORMAT_WITH_DASHES_FIRST_YEAR: 'YYYY-MM-DD',
        DATE_FORMAT_SHORT_MONTH_SHORT_YEAR: 'MM/YY',
        DATE_FORMAT_SHORT_MONTH_YEAR: 'MMM YYYY',
        DATE_FORMAT_WITH_SLASHES_DATETIME: 'DD/MM/YYYY [-] HH:mm',
        DATE_FORMAT_TIMESERIES: 'YYYY-MM-DDThh:mm:ssZZ',
        DATE_FORMAT_TIME_REDUCED: 'YYYY-MM-DD_hhmmss',
    },
    pt: {
        DATE_FORMAT: 'DD MMM YYYY',
        DATE_FORMAT_DAY_MONTH: 'DD MMM',
        DATE_FORMAT_EXTENDED: 'DD [de] MMM [de] YYYY',
        DATE_FORMAT_WITH_SLASHES: 'DD/MM/YYYY',
        DATE_FORMAT_WITH_DASHES: 'DD-MM-YYYY',
        DATE_FORMAT_WITH_DASHES_FIRST_YEAR: 'YYYY-MM-DD',
        DATE_FORMAT_DATETIME: 'DD MMM YYYY h:mm',
        DATE_FORMAT_SHORT_MONTH_SHORT_YEAR: 'MM/YY',
        DATE_FORMAT_SHORT_MONTH_YEAR: 'MMM YYYY',
        DATE_FORMAT_WITH_DASHES_DATETIME: 'YYYY-MM-DD - HH:mm',
        DATE_FORMAT_WITH_SLASHES_DATETIME: 'DD/MM/YYYY [-] HH:mm',
        DATE_FORMAT_TIMESERIES: 'YYYY-MM-DDThh:mm:ssZZ',
        DATE_FORMAT_TIME_REDUCED: 'YYYY-MM-DD_hhmmss',
    },
    fr: {
        DATE_FORMAT: 'DD MMM YYYY',
        DATE_FORMAT_DAY_MONTH: 'DD MMM',
        DATE_FORMAT_EXTENDED: 'DD [de] MMM [de] YYYY',
        DATE_FORMAT_WITH_SLASHES: 'DD/MM/YYYY',
        DATE_FORMAT_WITH_DASHES: 'DD-MM-YYYY',
        DATE_FORMAT_WITH_DASHES_FIRST_YEAR: 'YYYY-MM-DD',
        DATE_FORMAT_DATETIME: 'DD MMM YYYY h:mm',
        DATE_FORMAT_SHORT_MONTH_SHORT_YEAR: 'MM/YY',
        DATE_FORMAT_SHORT_MONTH_YEAR: 'MMM YYYY',
        DATE_FORMAT_WITH_DASHES_DATETIME: 'YYYY-MM-DD - HH:mm',
        DATE_FORMAT_WITH_SLASHES_DATETIME: 'DD/MM/YYYY [-] HH:mm',
        DATE_FORMAT_TIMESERIES: 'YYYY-MM-DDThh:mm:ssZZ',
        DATE_FORMAT_TIME_REDUCED: 'YYYY-MM-DD_hhmmss',
    },
    nl: {
        DATE_FORMAT: 'DD MMM YYYY',
        DATE_FORMAT_DAY_MONTH: 'DD MMM',
        DATE_FORMAT_EXTENDED: 'DD [de] MMM [de] YYYY',
        DATE_FORMAT_WITH_SLASHES: 'DD/MM/YYYY',
        DATE_FORMAT_WITH_DASHES: 'DD-MM-YYYY',
        DATE_FORMAT_WITH_DASHES_FIRST_YEAR: 'YYYY-MM-DD',
        DATE_FORMAT_DATETIME: 'DD MMM YYYY h:mm',
        DATE_FORMAT_SHORT_MONTH_SHORT_YEAR: 'MM/YY',
        DATE_FORMAT_SHORT_MONTH_YEAR: 'MMM YYYY',
        DATE_FORMAT_WITH_DASHES_DATETIME: 'YYYY-MM-DD - HH:mm',
        DATE_FORMAT_WITH_SLASHES_DATETIME: 'DD/MM/YYYY [-] HH:mm',
        DATE_FORMAT_TIMESERIES: 'YYYY-MM-DDThh:mm:ssZZ',
        DATE_FORMAT_TIME_REDUCED: 'YYYY-MM-DD_hhmmss',
    },
};

module.exports = DATE_FORMAT_TYPES;
